import React from 'react';
import Text from '../../../../Components/Base/Text/Text';
import { PatientSelectValue } from './PatientSelect';
import { useAppContext } from '../../../../Services/AppContext';

// @ts-ignore
import styles from './PatientSelectItem.module.scss';
import FormattedDate from '../../../../Components/FormattedDate';
import usePatientIdentification from '../../Hooks/usePatientIdentification';

interface PatientSelectItemProps {
	data: PatientSelectValue;
	selectOption: (data: { value: string; label: string; item: any }) => void;
}

const PatientSelectItem: React.FC<PatientSelectItemProps> = ({
	data,
	selectOption,
}) => {
	const { isLatam } = useAppContext();
	const { item }: PatientSelectValue = data;
	const { identification } = usePatientIdentification(item.user);

	const handleSelect = () => {
		selectOption({
			value: data.value,
			label: data.label,
			item: item,
		});
	};

	return (
		<div className={styles.wrapper} onClick={handleSelect}>
			<div className={styles.header}>
				<div className={styles.title}>{item.user.profile.fullName}</div>
			</div>
			<div className={styles.content}>
				{identification.value && (
					<div>
						<Text tx={identification.title} inline />: {identification.value}
					</div>
				)}
				{item?.user?.profile?.address?.fullAddress && (
					<div>
						<Text tx='base.shared.address' inline />:{' '}
						{item.user.profile.address.fullAddress}
					</div>
				)}
			</div>
		</div>
	);
};

export default PatientSelectItem;
